import { Component, Input } from "@angular/core";
import { DocumentService, AnnotationService } from "../../../shared/index";

@Component({
  selector: "annotation-buttons",
  templateUrl: "./annotation-buttons.component.html",
  styleUrl: "./annotation-buttons.component.css",
  standalone: false,
})
export class AnnotationButtonsComponent {
  @Input() annotationId: number = 0;
  @Input() documentId: number = 0;
  @Input() isPDF: boolean = false;

  public isDownloadingManualPDF: boolean = false;
  public isDownloadingAnnotationPDF: boolean = false;

  constructor(
    private _documentService: DocumentService,
    private _annotationService: AnnotationService
  ) {}

  public openManualPDF(): void {
    if (!this.documentId || this.documentId === 0) {
      console.error("Document ID not found for opening manual");
      return;
    }

    this.isDownloadingManualPDF = true;

    this._documentService.downloadPDF(this.documentId).subscribe(
      (response) => {
        this.isDownloadingManualPDF = false;

        const blob = new Blob([response.body], { type: "application/pdf" });
        const blobUrl = window.URL.createObjectURL(blob);

        // Open the blob URL in a new tab
        window.open(blobUrl, "_blank");

        // Clean up the blob URL after a short delay to allow the browser to load it
        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 1000);
      },
      (error: any) => {
        console.error("Failed to open manual PDF:", error);
        this.isDownloadingManualPDF = false;
      }
    );
  }

  public openAnnotationDocument(): void {
    if (!this.annotationId || this.annotationId === 0) {
      console.error("Annotation ID not found for opening");
      return;
    }

    if (this.isPDF) {
      // Handle PDF annotations using AnnotationService
      this.isDownloadingAnnotationPDF = true;

      this._annotationService.downloadPDF(this.annotationId).subscribe(
        (data: Blob) => {
          this.isDownloadingAnnotationPDF = false;

          // Create blob URL and open in new tab
          const blobUrl = window.URL.createObjectURL(data);
          window.open(blobUrl, "_blank");

          // Clean up the blob URL after a short delay to allow the browser to load it
          setTimeout(() => {
            window.URL.revokeObjectURL(blobUrl);
          }, 1000);
        },
        (error: any) => {
          console.error("Failed to open annotation PDF:", error);
          this.isDownloadingAnnotationPDF = false;
        }
      );
    } else {
      // Handle image annotations - use anchor tag approach
      const url = `api/Manuals/AnnotationImage?annotationId=${this.annotationId}`;
      window.open(url, "_blank");
    }
  }

  public getAnnotationImageUrl(): string {
    return `api/Manuals/AnnotationImage?annotationId=${this.annotationId}`;
  }
}
